var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 0h22v22H0zm5.638 9.144V16.5h2.337V9.144zM5.5 6.806c0 .756.55 1.307 1.306 1.307s1.307-.55 1.307-1.307S7.563 5.5 6.806 5.5c-.687 0-1.306.55-1.306 1.306m8.662 9.694h2.2v-4.537c0-2.27-1.374-3.025-2.68-3.025-1.17 0-1.995.756-2.2 1.237V9.144h-2.2V16.5h2.337v-3.919c0-1.031.687-1.581 1.375-1.581s1.168.344 1.168 1.512z",
  clipRule: "evenodd"
})));
export default SvgLinkedinCircle;